// useTomorrowPlan — fetches tomorrow's taper target + suggested schedule
// from /api/taper/tomorrow.
//
// Returns the standard ApiState shape from useApi. The endpoint returns
// 404 when the user has no active plan or the plan has ended — that
// surfaces here as status: 'error' and the consumer (TomorrowPlanCard)
// hides itself.

import { useApi, type ApiState } from './useApi';
import type { ApiClientError } from '../lib/api';

export interface TomorrowScheduleSlot {
  time: string; // 'HH:MM' local clock
  mg: number;
  confidence: 'high' | 'medium' | 'low';
}

export interface TomorrowPlanResponse {
  date: string; // YYYY-MM-DD in user TZ
  targetMg: number;
  isHold: boolean;
  holdReason: string | null;
  isFinalDay: boolean;
  suggestedSchedule: TomorrowScheduleSlot[];
  pattern: {
    observedDays: number;
    dosesAnalyzed: number;
    peaks: number;
  };
}

export function useTomorrowPlan(): ApiState<TomorrowPlanResponse> & {
  refresh: () => void;
} {
  return useApi<TomorrowPlanResponse>('/api/taper/tomorrow');
}

export type { ApiClientError };
